<div class="detail-page-card">
    <div class="pagination-table">
        <div class="detail-page-card-title">
            {{ isLoaded ? this.config.name : ('genericPaginationListManager.loading' | transloco: { name: this.config.name }) }}
        </div>

        @if (isLoaded) {
            <div>
                @if (currentData && currentData.length > 0) {
                    <table data-uiid="task-series-task-table" class="hoverable">
                        <thead>
                            <tr>
                                @for (column of columnInfo; track column) {
                                    <th
                                        (click)="setSort(column.fieldName)"
                                        [ngClass]="column.headerCssClass"
                                    >
                                        {{ column.prettyName }}
                                        @if (column.fieldName === sortColumn) {
                                            <i
                                                class="fas fa-sort-amount-{{
                                                    sortAsc ? 'down-alt' : 'down'
                                                }}"
                                            ></i>
                                        }
                                    </th>
                                }
                                @if (this.config.allowEdit) {
                                    <th class="th-fixed-icon"></th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of currentData; track row) {
                                <tr>
                                    @for (column of columnInfo; track column) {
                                        @if (
                                            column.formatType === FormatType.DateFormat ||
                                            column.formatType === FormatType.DateShortTimeFormat ||
                                            column.formatType === FormatType.DateTimeFormat
                                        ) {
                                            <td class="text-truncate date-text">
                                                {{ row[column.fieldName] | dateFormat }}
                                            </td>
                                        } @else if (column.fieldName === "statusDescription") {
                                            <td class="text-truncate inline-icon">
                                                <i
                                                    class="fas {{
                                                        row['statusDescription_ICON']
                                                    }} {{ row['statusDescription_COLOR_CLASS'] }} "
                                                ></i>
                                                <span>{{ row[column.fieldName] }}</span>
                                            </td>
                                        } @else if (column.fieldName === "scoreName") {
                                            <td class="text-truncate inline-icon">
                                                @if (
                                                    row["scoreName_COLOR"] === null ||
                                                    row["scoreName_COLOR"] === ""
                                                ) {
                                                    <i class="fas fa-stop status-attention"></i>
                                                } @else {
                                                    <i
                                                        [style.color]="row['scoreName_COLOR']"
                                                        class="fas fa-stop"
                                                    ></i>
                                                }

                                                <span>{{ row["scoreName"] }}</span>
                                            </td>
                                        } @else {
                                            <td class="text-truncate">
                                                <span [title]="row[column.fieldName]">
                                                    {{ row[column.fieldName] }}
                                                </span>
                                            </td>
                                        }
                                    }
                                    @if (this.config.allowEdit) {
                                        <td class="action-button">
                                            <i
                                                class="fas fa-up-right-from-square"
                                                [title]="'genericPaginationListManager.openItem' | transloco: { actionTitle: actionTitle }"
                                                (click)="openItem(row)"
                                            ></i>
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                }

                @if (allData && allData.length > 0) {
                    <div class="mt-2 navigation-bar">
                        <span
                            class="navigation-totals"
                            data-uiid="task-series-task-table-navigation-totals"
                        >
                            {{ 'genericPaginationListManager.paginationShowing' | transloco: { from: currentPage * pageSize + 1, to: currentPage * pageSize + currentData.length, total: allData.length } }}
                        </span>

                        @if (!isShowingAll && pageCount > 1) {
                            <nav class="pagination" data-uiid="task-series-task-table-pagination">
                                <ul class="pagination justify-content-end mb-0">
                                    <li class="page-item navigation-totals"></li>
                                    <li
                                        class="page-item"
                                        [class.disabled]="currentPage === 0"
                                        (click)="currentPage > 0 && setPagination(currentPage - 1)"
                                        data-uiid="task-series-task-table-pagination-previous"
                                    >
                                        <span class="page-link" role="button">
                                            <i class="fas fa-chevron-left"></i>
                                        </span>
                                    </li>

                                    <li
                                        class="page-item"
                                        [class.active]="currentPage === 0"
                                        (click)="setPagination(0)"
                                        data-uiid="task-series-task-table-pagination-first"
                                    >
                                        <span class="page-link">1</span>
                                    </li>

                                    @if (currentPage > 2) {
                                        <li class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                    }

                                    @if (currentPage > 1) {
                                        <li
                                            class="page-item"
                                            (click)="setPagination(currentPage - 1)"
                                            data-uiid="task-series-task-table-pagination-previous-page"
                                        >
                                            <span class="page-link">{{ currentPage }}</span>
                                        </li>
                                    }

                                    @if (currentPage !== 0 && currentPage !== pageCount - 1) {
                                        <li
                                            class="page-item active"
                                            data-uiid="task-series-task-table-pagination-current-page"
                                        >
                                            <span class="page-link">{{ currentPage + 1 }}</span>
                                        </li>
                                    }

                                    @if (currentPage < pageCount - 2) {
                                        <li
                                            class="page-item"
                                            (click)="setPagination(currentPage + 1)"
                                            data-uiid="task-series-task-table-pagination-next-page"
                                        >
                                            <span class="page-link">{{ currentPage + 2 }}</span>
                                        </li>
                                    }

                                    @if (currentPage < pageCount - 3) {
                                        <li class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                    }

                                    @if (pageCount > 1) {
                                        <li
                                            class="page-item"
                                            [class.active]="currentPage === pageCount - 1"
                                            (click)="setPagination(pageCount - 1)"
                                            data-uiid="task-series-task-table-pagination-last"
                                        >
                                            <span class="page-link">{{ pageCount }}</span>
                                        </li>
                                    }

                                    <li
                                        class="page-item"
                                        [class.disabled]="currentPage >= pageCount - 1"
                                        (click)="
                                            currentPage < pageCount - 1 &&
                                                setPagination(currentPage + 1)
                                        "
                                        data-uiid="task-series-task-table-pagination-next"
                                    >
                                        <span class="page-link" [attr.aria-label]="'genericPaginationListManager.next' | transloco">
                                            <i class="fas fa-chevron-right"></i>
                                        </span>
                                    </li>
                                </ul>
                            </nav>
                        }
                        @if (pageCount > 1) {
                            <div class="page-item show-all-items ms-2" (click)="toggleAllItems()">
                                @if (isShowingAll) {
                                    <span data-uiid="task-series-task-table-show-less">
                                        {{ 'genericPaginationListManager.showLess' | transloco }}
                                    </span>
                                } @else {
                                    <span data-uiid="task-series-task-table-show-all">
                                        {{ 'genericPaginationListManager.showAll' | transloco: { count: allData.length } }}
                                    </span>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        } @else {
            <div class="fancy-loader"></div>
        }
    </div>
</div>
